<template>
  <div id="creator_country_agency"  :class="isFull === 1 ? 'creator_country_agency top_information1' : ' creator_country_agency'">
    <van-nav-bar
        left-arrow
        placeholder
        fixed
        :title="$t('column.Revenue_records')"
        @click-left="goBack"
    />
    <van-row>
        <van-col span="22" offset="1" class="creator_country_agency_seach">
          <div class="search-container">
            <div class="search-top-row">
              <div class="month-selector" @click="showMonthPicker = true">
                <van-icon name="notes-o" size="18" />
                <span class="month-text">{{ search_month }}</span>
                <van-icon name="arrow-down" />
              </div>
            </div>
          </div>
          <!-- Popups -->
          <van-popup v-model="showMonthPicker" position="bottom">
            <van-datetime-picker
              v-model="currentMonthDate"
              type="year-month"
              :min-date="minDate"
              :max-date="maxDate"
              @confirm="onConfirmMonth"
              @cancel="showMonthPicker = false"
            />
          </van-popup>
        </van-col>
      <van-col span="24">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('other.there_is_no_more')"
          :loading-text="$t('other.Loading')"
        >
          <van-cell v-for="item in list" :key="item.id">
             <van-col span="24" class="creator_country_agency_type">
                <van-col span="22" offset="1" class="creator_country_agency_type_income_date">{{ item.date_time }}</van-col>
                <van-col span="11" offset="1" class="creator_country_agency_type_income_basic">
                    <van-col span="24" class="creator_country_agency_type_income_name">{{ $t('column.basic_income') }}: </van-col>
                    <van-col span="24" class="creator_country_agency_type_income_val"><img src="../assets/img/coin9.png" />{{ item.basic_income_k }}</van-col>
                </van-col>
                <van-col span="11" class="creator_country_agency_type_income_bonus">
                    <van-col span="24" class="creator_country_agency_type_income_name">{{ $t('column.bonus_ncome') }}: </van-col>
                    <van-col span="24" class="creator_country_agency_type_income_val"><img src="../assets/img/coin9.png" />{{ item.bonus_income_k }}</van-col>
                </van-col>
             </van-col>
          </van-cell>
        </van-list>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import '@/assets/css/style.css'
import axios from "axios";
import {Toast} from "vant";
import dayjs from "dayjs";

export default {
  data() {
    return {
      isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
      list: [],
      loading: false,
      finished: false,
      page: 1,
      search_month: dayjs().format('YYYY-MM'),
      search_user_id: '',
      showMonthPicker: false,
      currentMonthDate: new Date(),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2090, 11, 31),
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    this.search_user_id = this.$route.query.search_user_id ? this.$route.query.search_user_id : ''
    this.get_list()
  },
  methods: {
    onConfirmMonth(value) {
      this.search_month = dayjs(value).format('YYYY-MM');
      this.showMonthPicker = false;
      this.get_list();
    },
    goBack() {
      this.$router.go(-1);
    },
    get_list(){
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator_country&act=create_user_income_log", {
        params : {
          token: token,
          date_ym: this.search_month,
          search_user_id: this.search_user_id,
        }
      }).then(res =>{
        this.loading = false;
        this.list = res.data.data.list
       this.finished = true
      })
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/creator_country_user_income.vue